import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import Membership from '../../containers/membership-request/Membership'

const MembershipPane = (props: RouteComponentProps<any>) => {
  return (
    <div>
      <Switch>
        <Route path={`${props.match.path}`} component={Membership} />
      </Switch>
    </div>
  )
}

export default MembershipPane



// WEBPACK FOOTER //
// ./src/components/membership-request/MembershipPane.tsx